
export const KB_URL_GROUP_THRESHOLD = 5;

export function normalizeUrlString(input) {
  const trimmed = String(input || '').trim();
  if (!trimmed) return null;
  try {
    const withProto = /^https?:\/\//i.test(trimmed) ? trimmed : `https://${trimmed}`;
    const u = new URL(withProto);
    if (u.protocol !== 'http:' && u.protocol !== 'https:') return null;
    return u.href;
  } catch {
    return null;
  }
}

export function parseStoredUrls(value) {
  if (!value || !String(value).trim()) return [];
  const parts = String(value)
    .split(/[\s,;|\n\r\t]+/)
    .map((s) => s.trim())
    .filter(Boolean);
  const seen = new Set();
  const out = [];
  for (const p of parts) {
    const n = normalizeUrlString(p);
    if (!n || seen.has(n)) continue;
    seen.add(n);
    out.push(n);
  }
  return out;
}

export function serializeUrls(urls) {
  return urls.join(', ');
}

export function splitBulkText(text) {
  return String(text || '')
    .split(/[\s,;|\n\r\t]+/)
    .map((s) => s.trim())
    .filter(Boolean);
}

export function getHostnameKey(urlString) {
  try {
    return new URL(urlString).hostname.replace(/^www\./i, '').toLowerCase();
  } catch {
    return '—';
  }
}

export function urlPillLabel(urlString) {
  try {
    const u = new URL(urlString);
    const host = u.hostname.replace(/^www\./i, '');
    const path = u.pathname && u.pathname !== '/' ? u.pathname : '';
    const combined = path ? `${host}${path}` : host;
    if (combined.length > 48) return `${combined.slice(0, 46)}…`;
    return combined;
  } catch {
    return urlString.length > 48 ? `${urlString.slice(0, 46)}…` : urlString;
  }
}
